import mock from "./mock"
import "./navbar/navbarSearch"
import "./navbar/navbarBookmarkSearch"
import "./auth/authentication"
import "./apps/calendar"
import "./apps/todo"
mock.onAny().passThrough()
